import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { MESSAGES } from "~/resources/Message";
import { useAppSelector } from "~/hooks/appSelector";
import { FormCloudEnviroment} from "~/models/Comons";
import { useSaveCloudEnviromentMutation, useUpdateCloudEnviromentMutation } from "~/services/cloudenviroment";
import { selectProvider } from "~/store/feature/Provider";

export const UseFormCloudEnviroment = (
  onCloseModal: () => void,
  refetch: () => void,
  id:number
) => {
  const { cloudProviderName } = useAppSelector(selectProvider);
  const [saveCloudEnviroment, { isLoading }] = useSaveCloudEnviromentMutation();
  const [updateCloudEnviroment] = useUpdateCloudEnviromentMutation();

  const {
    formState: { errors },
    handleSubmit,
    control,
    reset,
    setValue
  } = useForm<FormCloudEnviroment>({
    defaultValues: {
      environmentName:  "",
      environmentDescription:  "",
      datacenterName:"",
      datacenterDescription:"",
      location:  "",
      cloudProviderId:undefined,
      iac:"",
      authenticationConfig:"",
    },
  });

  const submitForm = async (_data: FormCloudEnviroment) => {
    console.log("data", _data);
    try {
      const parsedData: FormCloudEnviroment = {
        ..._data,
        cloudProviderId: _data.cloudProviderId.value,
      };
  
      const response = await saveCloudEnviroment(parsedData).unwrap();
      if (response.success) {
        toast.success(response?.message);
      } else {
        throw new Error('Save operation failed: No success response');
      }
    } catch (error: any) {
      const errorMessage =
        error?.data?.detail || error?.detail || MESSAGES.MessageErrorSavingCloudEnviroment;
      toast.error(errorMessage);
      console.error('Error', error);
    } finally {
      refetch();
      onCloseModal();
      console.log('submitForm: completed');
    }
  };
   
  
  const updateForm = async (_data: FormCloudEnviroment) => {
    if (!id) {
      toast.error("Missing environment ID for update.");
      return;
    }
  
    const parsedData: FormCloudEnviroment = {
      ..._data,
      cloudProviderId: _data.cloudProviderId.value??3,
    };
  
    try {
      const response = await updateCloudEnviroment({
        id,
        data: parsedData,
      }).unwrap();
  
    
      if (response.success) {
        toast.success(response?.message);
      } else {
        throw new Error('Save operation failed: No success response');
      }
    } catch (error: any) {
      const errorMessage =
        error?.data?.detail || error?.detail || MESSAGES.MessageErrorSavingCloudEnviroment;
      toast.error(errorMessage);
      console.error('Error', error);
    } finally {
      refetch();
      onCloseModal();
      console.log('submitForm: completed');
    }
  };
  
  
  
  return {
    handleSubmit,
    control,
    errors,
    submitForm,
    updateForm,
    isLoading,
    cloudProviderName,
    reset,
    setValue
  };
};